import { motion } from 'framer-motion';
import { Button } from '../../components/common';
import { usePageTitle } from '../../hooks/usePageTitle';

export default function NotFound() {
  usePageTitle('Página Não Encontrada');
  return (
    <div className="min-h-screen bg-gradient-to-br from-sand-100 to-olive-100 flex items-center justify-center px-4 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 left-20 text-6xl text-olive-300 opacity-30">
        <i className="ri-map-2-line"></i>
      </div>
      <div className="absolute top-32 right-20 text-5xl text-sand-400 opacity-30">
        <i className="ri-compass-3-line"></i>
      </div>
      <div className="absolute bottom-20 left-32 text-4xl text-olive-300 opacity-30">
        <i className="ri-suitcase-2-line"></i>
      </div>
      <div className="absolute bottom-32 right-32 text-5xl text-sand-400 opacity-30">
        <i className="ri-plane-line"></i>
      </div>

      <motion.div 
        className="text-center relative z-10"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* Compass icon */}
        <motion.div
          className="text-8xl text-olive-500 mb-8"
          animate={{ 
            rotate: [0, 360],
          }}
          transition={{ 
            duration: 8, 
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <i className="ri-compass-discover-line"></i>
        </motion.div>

        <h1 className="text-9xl font-bold text-olive-600 mb-4">
          404
        </h1>
        
        <h2 className="text-3xl font-semibold text-earth-700 mb-4">
          Página não encontrada
        </h2>
        
        <p className="text-xl text-earth-600 mb-8 max-w-md mx-auto">
          Parece que esta página não existe ou foi movida. 
          Vamos te ajudar a encontrar o caminho de volta.
        </p>

        <div className="bg-white/80 backdrop-blur-sm inline-block px-8 py-4 rounded-xl mb-8 shadow-sm">
          <p className="text-earth-700">
            <i className="ri-map-pin-line text-olive-500 mr-2"></i>
            Esta rota não está no nosso mapa.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            to="/" 
            size="lg"
          >
            <i className="ri-home-4-line mr-2"></i>
            Voltar para a Home
          </Button>
          <Button 
            to="/contato" 
            variant="outline" 
            size="lg"
          >
            <i className="ri-message-3-line mr-2"></i>
            Falar Conosco
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
